module.exports = __webpack_public_path__ + "media/images/flags/16/Saint-Lucia-5fd42003e19006a3289decce468b6a81.png";